<template>
  <div>
    <template>
      <div>
        <div class="summary">
          <div class="board">
            <h5>Relatório de Auditoria</h5>
            <div class="container">
              <div class="item">
                <header>
                  <h2>Total de pesquisa</h2>
                </header>
                <div class="description">
                  <span>
                    <animated-number
                      :value="totalAnswers"
                      :formatValue="formatToPrice"
                      :duration="1000"
                    />
                  </span>
                </div>
              </div>

              <div class="item">
                <header>
                  <h2>IP's repetidos</h2>
                </header>
                <div v-if="loadingIp" class="description">
                  <span>
                    <animated-number
                      :value="totalIps"
                      :formatValue="formatToPrice"
                      :duration="1000"
                    />
                  </span>
                </div>
                <div v-else class="mt-1">
                  <b-spinner
                    variant="success"
                    type="grow"
                    label="Spinning"
                    class="bg-primary"
                  ></b-spinner>
                </div>
                <b-button class="btn-details" v-b-modal.modal-ip
                  ><i class="fas fa-search icon-custom"></i
                ></b-button>
                <b-modal
                  size="xl"
                  id="modal-ip"
                  title="IP's repetidos"
                  class="custom-modal"
                  :hide-footer="true"
                  @hidden="closeModal()"
                >
                  <div style="display: flex; width: 50%">
                    <input
                      type="text"
                      class="form-control"
                      id="input-compnay-users"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderSearch',
                      )}`"
                      v-model="filterIp"
                      @keyup="handleFilterIp"
                    />

                    <button
                      class="btn btn-outline-primary"
                      title="Limpar filtro"
                      @click="cleanFilterIp"
                    >
                      Limpar
                    </button>
                  </div>

                  <br />

                  <b-table
                    striped
                    :fields="fields"
                    :items="itemsIp"
                    :per-page="10"
                    :current-page="pageIp"
                    responsive
                  >
                    <template v-slot:cell(action)="row">
                      <div style="max-width: 80%">
                        <a :href="`/treatments/${row.item.id}`" target="_blank">
                          <i class="fas fa-search icon-custom"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>

                  <paginate
                    class="pagination-area-answers"
                    v-model="pageIp"
                    :pageCount="Math.ceil(totalIps / 5)"
                    :clickHandler="getIp"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate>

                  <div style="text-align: right; margin-top: -60px">
                    <button
                      style="border: none; background: none"
                      @click="exportIps"
                    >
                      <span class="xls">
                        <i class="fas fa-file-download"></i>
                      </span>
                    </button>
                  </div>
                </b-modal>
              </div>

              <div class="item">
                <header>
                  <h2>Telefones repetidos</h2>
                </header>
                <div v-if="loadingPhone" class="description">
                  <span>
                    <animated-number
                      :value="totalPhone"
                      :formatValue="formatToPrice"
                      :duration="1000"
                    />
                  </span>
                </div>
                <div v-else class="mt-1">
                  <b-spinner
                    variant="success"
                    type="grow"
                    label="Spinning"
                    class="bg-primary"
                  ></b-spinner>
                </div>
                <b-button class="btn-details" v-b-modal.modal-phone
                  ><i
                    style="cursor: pointer; text-align: right; font-size: 24px"
                    class="fas fa-search"
                  ></i
                ></b-button>

                <b-modal
                  size="xl"
                  id="modal-phone"
                  title="Telefones repetidos"
                  :hide-footer="true"
                  @hidden="closeModal()"
                >
                  <div style="display: flex; width: 50%">
                    <input
                      type="text"
                      class="form-control"
                      id="input-compnay-users"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderSearch',
                      )}`"
                      v-model="filterPhone"
                      @keyup="handleFilterPhone"
                    />

                    <button
                      class="btn btn-outline-primary"
                      title="Limpar filtro"
                      @click="cleanFilterPhone"
                    >
                      Limpar
                    </button>
                  </div>

                  <br />

                  <b-table
                    striped
                    :fields="fields"
                    :items="itemsPhone"
                    :per-page="10"
                    :current-page="pagePhone"
                    responsive
                  >
                    <template v-slot:cell(action)="row">
                      <div style="max-width: 80%">
                        <a :href="`/treatments/${row.item.id}`" target="_blank">
                          <i class="fas fa-search icon-custom"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>

                  <paginate
                    class="pagination-area-answers"
                    v-model="pagePhone"
                    :pageCount="Math.ceil(totalPhone / 5)"
                    :clickHandler="getPhone"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate>

                  <div style="text-align: right; margin-top: -60px">
                    <button
                      style="border: none; background: none"
                      @click="exportPhones"
                    >
                      <span class="xls">
                        <i class="fas fa-file-download"></i>
                      </span>
                    </button>
                  </div>
                </b-modal>
              </div>

              <div class="item">
                <header>
                  <h2>E-mails repetidos</h2>
                </header>
                <div v-if="loadingEmail" class="description">
                  <span>
                    <animated-number
                      :value="totalEmail"
                      :formatValue="formatToPrice"
                      :duration="1000"
                    />
                  </span>
                </div>
                <div v-else class="mt-1">
                  <b-spinner
                    variant="success"
                    type="grow"
                    label="Spinning"
                    class="bg-primary"
                  ></b-spinner>
                </div>
                <b-button class="btn-details" v-b-modal.modal-email
                  ><i
                    style="cursor: pointer; text-align: right; font-size: 24px"
                    class="fas fa-search"
                  ></i
                ></b-button>

                <b-modal
                  size="xl"
                  id="modal-email"
                  title="Emails repetidos"
                  :hide-footer="true"
                  @hidden="closeModal()"
                >
                  <div style="display: flex; width: 50%">
                    <input
                      type="text"
                      class="form-control"
                      id="input-compnay-users"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderSearch',
                      )}`"
                      v-model="filterEmail"
                      @keyup="handleFilterEmail"
                    />

                    <button
                      class="btn btn-outline-primary"
                      title="Limpar filtro"
                      @click="cleanFilterEmail"
                    >
                      Limpar
                    </button>
                  </div>

                  <br />

                  <b-table
                    striped
                    :fields="fields"
                    :items="itemsEmail"
                    :per-page="10"
                    :current-page="pageEmail"
                    responsive
                  >
                    <template v-slot:cell(action)="row">
                      <div style="max-width: 80%">
                        <a :href="`/treatments/${row.item.id}`" target="_blank">
                          <i class="fas fa-search icon-custom"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>

                  <paginate
                    class="pagination-area-answers"
                    v-model="pageEmail"
                    :pageCount="Math.ceil(totalEmail / 5)"
                    :clickHandler="getEmail"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate>

                  <div style="text-align: right; margin-top: -60px">
                    <button
                      style="border: none; background: none"
                      @click="exportEmails"
                    >
                      <span class="xls">
                        <i class="fas fa-file-download"></i>
                      </span>
                    </button>
                  </div>
                </b-modal>
              </div>

              <!-- <div class="item">
                <header>
                  <h2>VisitorIds repetidos</h2>
                </header>
                <div v-if="loadingVisitorId" class="description">
                  <span>
                    <animated-number
                      :value="totalVisitorId"
                      :formatValue="formatToPrice"
                      :duration="1000"
                    />
                  </span>
                </div>
                <div v-else class="mt-1">
                  <b-spinner
                    variant="success"
                    type="grow"
                    label="Spinning"
                    class="bg-primary"
                  ></b-spinner>
                </div>
                <b-button class="btn-details" v-b-modal.modal-visitors
                  ><i
                    style="cursor: pointer; text-align: right; font-size: 24px"
                    class="fas fa-search"
                  ></i
                ></b-button>
                <b-modal
                  size="xl"
                  id="modal-visitors"
                  title="VisitorIds repetidos"
                  :hide-footer="true"
                  @hidden="closeModal()"
                >
                  <div style="display: flex; width: 50%">
                    <input
                      type="text"
                      class="form-control"
                      id="input-compnay-users"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderSearch',
                      )}`"
                      v-model="filterVisitorId"
                      @keyup="handleFilterVisitorsIds"
                    />

                    <button
                      class="btn btn-outline-primary"
                      title="Limpar filtro"
                      @click="cleanFilterVisitorsIds"
                    >
                      Limpar
                    </button>
                  </div>

                  <br />
                  <template v-if="loadingVisitorId">
                  <b-table
                    striped
                    :fields="fieldsVisitorId"
                    :items="itemsVisitorId"
                    :per-page="10"
                    :current-page="pageVisitorId"
                    responsive
                  >
                    <template v-slot:cell(action)="row">
                      <div style="max-width: 80%">
                        <a
                          :href="`/treatments/${row.item.actionId}`"
                          target="_blank"
                        >
                          <i class="fas fa-search icon-custom"></i>
                        </a>
                      </div>
                    </template>
                    <template v-slot:cell(date)="row">
                      <div style="max-width: 80%">
                        {{ formatDate(row.item.date) }}
                      </div>
                    </template>
                  </b-table>
                  </template>
                  <template v-else>
                      <b-spinner
                      variant="success"
                      type="grow"
                      label="Spinning"
                      class="bg-primary"
                    ></b-spinner>
                  </template>

                  <paginate
                    class="pagination-area-answers"
                    v-model="pageVisitorId"
                    :pageCount="Math.ceil(totalVisitorId / 5)"
                    :clickHandler="getVisitorIds"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate> -->

                  <!-- <div style="text-align: right; margin-top: -60px">
                    <button
                      style="border: none; background: none"
                      @click="exportIps"
                    >
                      <span class="xls">
                        <i class="fas fa-file-download"></i>
                      </span>
                    </button>
                  </div> -->
                <!-- </b-modal>
              </div> -->
            </div>
          </div>
        </div>

        <div style="background: #f0f0f0">
          <p>
            <strong>**Total de pesquisa</strong> = Total de pesquisas realizadas
            no período selecionado <br />

            <strong>**IP's repetidos</strong> = IP's iguais para clientes
            diferentes<br />

            <strong>**Telefones repetidos</strong> = Telefones iguais para
            clientes diferentes <br />

            <strong>**E-mails repetidos</strong> = E-mails iguais para clientes
            diferentes <br />
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { lightFormat } from 'date-fns';
import Paginate from 'vuejs-paginate';
import animatedNumber from 'animated-number-vue';
import XLSX from 'xlsx';
import api from '../../../../services/api';

export default {
  name: 'AuditReport',

  components: {
    Paginate,
    animatedNumber,
  },

  data: () => ({
    fields: [],
    items: [],
    itemsIp: [],
    itemsPhone: [],
    itemsEmail: [],
    itemsVisitorId: [],
    totalAnswers: 0,
    research: [],
    page: 1,
    pageIp: 1,
    pagePhone: 1,
    pageEmail: 1,
    pageVisitorId: 1,
    limit: 5,
    totalItems: 0,
    totalIps: 0,
    totalPhone: 0,
    totalEmail: 0,
    totalVisitorId: 0,
    ip: 0,
    phone: 0,
    loadingIp: false,
    loadingPhone: false,
    loadingEmail: false,
    loadingVisitorId: false,
    filterIp: null,
    filterPhone: null,
    filterEmail: null,
    filterVisitorId: null,
  }),

  methods: {
    closeModal() {
      this.filterIp = null;
      this.filterPhone = null;
      this.filterEmail = null;
      this.filterVisitorId = null;
      this.pagePhone = 1;
      this.pageEmail = 1;
      this.pageIp = 1;
      this.pageVisitorId = 1;
    },

    exportEmails() {
      const header = [
        'id',
        'controlId',
        'data',
        'cliente',
        'telefone',
        'concessionaria',
        'email',
        'ip',
        'canal'
      ];

      const arr = [];

      this.itemsEmail.forEach((el) => {
        arr.push({
          id: el.id,
          controlId: el.controlId,
          data: el.date,
          cliente: el.client,
          telefone: el.phone,
          email: el.email,
          ip: el.ip,
          concessionaria: el.concessionaria,
          canal: el.channel
        });
      });

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('emails-repetidos');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['emails-repetidos'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'emails-repetidos.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    exportPhones() {
      const header = [
        'id',
        'controlId',
        'data',
        'cliente',
        'telefone',
        'concessionaria',
        'email',
        'ip',
        'canal'
      ];

      const arr = [];

      this.itemsPhone.forEach((el) => {
        arr.push({
          id: el.id,
          controlId: el.controlId,
          data: el.date,
          cliente: el.client,
          telefone: el.phone,
          email: el.email,
          ip: el.ip,
          concessionaria: el.concessionaria,
          canal: el.channel,
        });
      });

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('telefones-repetidos');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['telefones-repetidos'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'telefones-repetidos.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    exportIps() {
      const header = [
        'id',
        'controlId',
        'data',
        'cliente',
        'telefone',
        'concessionaria',
        'email',
        'ip',
        'canal'
      ];

      const arr = [];

      this.itemsIp.forEach((el) => {
        arr.push({
          id: el.id,
          controlId: el.controlId,
          data: el.date,
          cliente: el.client,
          telefone: el.phone,
          email: el.email,
          ip: el.ip,
          concessionaria: el.concessionaria,
          canal: el.channel
        });
      });

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('ips-repetidos');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['ips-repetidos'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'ips-repetidos.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    exportVisitorsIds(){
      const header = [
        'controlId',
        'data',
        'cliente',
        'telefone',
        'concessionaria',
        'email',
        'visitorId',
        'canal'
      ];

      const arr = [];

      this.itemsVisitorId.forEach((el) => {
        arr.push({
          controlId: el.controlId,
          data: el.date,
          cliente: el.client,
          telefone: el.phone,
          email: el.email,
          visitorId: el.visitorId,
          concessionaria: el.concessionaria,
          canal: el.channel
        });
      });

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('visitorIds-repetidos');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['visitorIds-repetidos'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'visitorIds-repetidos.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    formatToPrice(value) {
      return `${value.toFixed(0)}`;
    },

    cleanFilterEmail() {
      this.filterEmail = null;
      this.getEmail('isModal');
    },

    cleanFilterVisitorsIds(){
      this.filterVisitorId = null;
      this.getVisitorIds('isModal');
    },

    handleFilterEmail() {
      if (this.filterEmail !== null && this.filterEmail !== '') {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getEmail('isModal'), 600);
      }

      if (this.filterEmail === '') {
        this.filterEmail = null;
        this.pageEmail = 1;
        this.getEmail('isModal');
      }
    },

    handleFilterVisitorsIds(){
      if (this.filterVisitorId !== null && this.filterVisitorId !== '') {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getVisitorIds('isModal'), 600);
      }

      if (this.filterVisitorId === '') {
        this.filterVisitorId = null;
        this.pageVisitorId = 1;
        this.getVisitorIds('isModal');
      }
    },

    cleanFilterPhone() {
      this.filterPhone = null;
      this.getPhone();
    },

    handleFilterPhone() {
      if (this.filterPhone !== null && this.filterPhone !== '') {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getPhone('isModal'), 600);
      }

      if (this.filterPhone === '') {
        this.filterPhone = null;
        this.pagePhone = 1;
        this.getPhone('isModal');
      }
    },

    cleanFilterIp() {
      this.filterIp = null;
      this.getIp('isModal');
    },

    handleFilterIp() {
      if (this.filterIp !== null && this.filterIp !== '') {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getIp('isModal'), 600);
      }

      if (this.filterIp === '') {
        this.filterIp = null;
        this.page = 1;
        this.getIp('isModal');
      }
    },

    async getEmail(isModal) {
      this.itemsEmail = [];

      this.loadingEmail = false;

      const response = await api.get('/reports/audit-mercedes-email', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          page: this.pageIp,
          limit: this.limit,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          filter: this.filterEmail,
        },
      });

      this.research = response.data;

      this.research.email.emailsClients.map((obj) => {
        this.itemsEmail.push({
          id: obj.id,
          controlId: obj.controlId,
          date: this.formatDate(obj.date),
          client: obj.name,
          phone: obj.phone,
          ip: obj.ipAddress,
          action: obj._id,
          email: obj.email,
          concessionaria: obj.ih1 === null ? '-' : obj.ih1,
          channel: obj.channel
        });
      });

      if (isModal !== 'isModal') {
        this.totalEmail = this.research.email.emailsEqual;
      }

      this.loadingEmail = true;
    },

    async getPhone(isModal) {
      this.itemsPhone = [];

      this.loadingPhone = false;

      const response = await api.get('/reports/audit-mercedes-phone', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          page: this.pageIp,
          limit: this.limit,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          filter: this.filterPhone,
        },
      });

      this.research = response.data;

      this.research.phone.phoneClients.map((obj) => {
        this.itemsPhone.push({
          id: obj.id,
          controlId: obj.controlId,
          date: this.formatDate(obj.date),
          client: obj.name,
          phone: obj.phone,
          ip: obj.ipAddress,
          action: obj._id,
          email: obj.email,
          concessionaria: obj.ih1 === null ? '-' : obj.ih1,
          channel: obj.channel
        });
      });

      if (isModal !== 'isModal') {
        this.totalPhone = this.research.phone.phoneEqual;
      }

      this.loadingPhone = true;
    },

    async getIp(isModal) {
      this.itemsIp = [];

      this.loadingIp = false;

      const response = await api.get('/reports/audit-mercedes-ip', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          page: this.pageIp,
          limit: this.limit,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          filter: this.filterIp,
        },
      });

      this.research = response.data;

      this.research.ips.clientsIps.map((obj) => {
        this.itemsIp.push({
          id: obj.id,
          controlId: obj.controlId,
          date: this.formatDate(obj.date),
          client: obj.name,
          phone: obj.phone,
          ip: obj.ipAddress,
          action: obj._id,
          email: obj.email,
          concessionaria: obj.ih1 === null ? '-' : obj.ih1,
          channel: obj.channel,
        });
      });

      if (isModal !== 'isModal') {
        this.totalIps = this.research.ips.ipEqual;
      }

      this.loadingIp = true;
    },

    async getVisitorIds(isModal) {
      // this.loadingVisitorId = false;

      // this.itemsVisitorId = [];

      // const response = await api.get('/reports/audit-mercedes-visitors', {
      //   headers: {
      //     'x-access-token': this.userAuth.token,
      //   },
      //   params: {
      //     actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
      //     startDate: this.calendarDates.start,
      //     endDate: this.calendarDates.end,
      //     ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
      //     ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
      //     metric: this.myMetric ? this.myMetric : null,
      //     groupId: this.actionGroupData._id,
      //     indicator: this.indicatorName,
      //     page: this.pageVisitorId,
      //     limit: this.limit,
      //     indicatorValue: this.indicatorData.value,
      //     indicatorRange: this.indicatorData.range,
      //     filter: this.filterVisitorId,
      //   },
      // });

      // this.research = response.data;

      this.research.visitors.visitorsIds.map((obj) => {
        this.itemsVisitorId.push({
          id: obj.id,
          controlId: obj.controlId,
          date: obj.date,
          client: obj.name,
          phone: obj.phone,
          ip: obj.ipAddress,
          action: obj.id,
          email: obj.email,
          concessionaria: obj.ih1 === null ? '-' : obj.ih1,
          visitorId: obj.visitorId,
          channel: obj.channel
        });
      });

      // this.research.visitors.visitorsIds.map((obj) => {
      //   this.itemsVisitorId.push({
      //     id: obj.id,
      //     controlId: obj.controlId,
      //     date: obj.date,
      //     client: obj.name,
      //     phone: obj.phone,
      //     ip: obj.ipAddress,
      //     action: obj._id,
      //     email: obj.email,
      //     concessionaria: obj.ih1 === null ? '-' : obj.ih1,
      //     visitorId: obj.visitorId
      //   });
      // });

      // if (isModal !== 'isModal') {
      //   this.totalVisitorId = this.research.visitors.totalVisitors;
      // }

      // this.loadingVisitorId = true;
    },

    async getMercedesData() {
      this.items = [];

      const response = await api.get('/reports/audit-mercedes', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          page: this.page,
          limit: this.limit,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      this.research = response.data;

      this.totalAnswers = this.research.totalAnswers;
    },

    formatDate(actionDate) {
      return lightFormat(new Date(actionDate), 'dd/MM/yyyy');
    },
  },

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myActionId: function watchmyActionId() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    calendarDates: function watchCalendarDates() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myIh1: function watchMyIh1() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myIh2: function watchMyIh2() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    myMetric: function watchMyMetric() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getMercedesData();
      this.getIp();
      this.getPhone();
      this.getEmail();
      this.getVisitorIds();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getMercedesData();
      await this.getIp();
      await this.getPhone();
      await this.getEmail();
      await this.getVisitorIds();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.getMercedesData();
    this.getIp();
    this.getPhone();
    this.getEmail();
    this.getVisitorIds();

    this.fields = [
      {
        key: 'controlId',
        label: 'ControlId',
      },
      {
        key: 'date',
        label: 'Data',
      },
      {
        key: 'client',
        label: 'Cliente',
      },
      {
        key: 'phone',
        label: 'Telefone',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'ip',
        label: 'Ip',
      },
      {
        key: 'concessionaria',
        label: 'Concessionaria',
      },
      {
        key: 'channel',
        label: 'Canal',
      },
      {
        key: 'action',
        label: 'Ação',
      },
    ];

    this.fieldsVisitorId = [
      {
        key: 'controlId',
        label: 'ControlId',
      },
      {
        key: 'date',
        label: 'Data',
      },
      {
        key: 'client',
        label: 'Cliente',
      },
      {
        key: 'phone',
        label: 'Telefone',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'visitorId',
        label: 'VisitorId',
      },
      {
        key: 'ip',
        label: 'Ip',
      },
      {
        key: 'concessionaria',
        label: 'Concessionaria',
      },
      {
        key: 'channel',
        label: 'Canal',
      },
      {
        key: 'action',
        label: 'Ação',
      }
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.modal-dialog.modal-xl {
  max-width: 1440px;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 10px;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
  outline: none;
}

.pagination-area-answers >>> .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background: #4ce595;
  border-color: #4ce595;
  outline: none;
}

.pagination-area-answers a {
  outline: none;
}

.icon-custom {
  cursor: pointer;
  text-align: right;
  font-size: 24px;
  color: #4ce595;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px auto;
  max-width: 100%;
}

.item {
  width: calc(20% - 20px);
  margin-bottom: 20px;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 9px -6px #000000;
  box-shadow: 0px 0px 9px -6px #000000;
  border-radius: 5px;
  overflow: hidden;
  padding: 5px 8px;
}

.btn-details {
  justify-content: right;
  display: flex;
  width: 100%;
  background: #fff;
  cursor: pointer;
  text-align: right;
  font-size: 24px;
  border: none;
  color: #4ce595;
}

@media (max-width: 768px) {
  .item {
    width: calc(50% - 20px);
  }

  .item:nth-child(even) {
    margin-right: 0;
  }

  .item:nth-child(odd) {
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .item {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }
}

.item {
  &:hover {
    -webkit-box-shadow: 0px 0px 12px -6px #000000;
    box-shadow: 0px 0px 12px -6px #000000;
  }

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;

    h2 {
      font-size: 11px;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;

    span {
      font-size: 35px;
      font-weight: bold;

      & + span {
        margin-top: -3px;
        font-size: 12px;
      }
    }
  }

  &:last-of-type {
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/mercedes-audit-report/index.vue